import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  views: number;
  category: string;
  date: string;
  tags: string[];
  featured?: boolean;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  duration,
  views,
  date,
  tags,
  featured,
}: VideoCardProps) {
  return (
    <Link
      to={`/video/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-2xl mb-3 aspect-[16/10]">
        <img
          src={thumbnail}
          alt={title}
          title={`${title} - 吃瓜视频独家爆料`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded-md">
          {duration}
        </span>
        {featured && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            热门
          </span>
        )}
      </div>
      <h3 className="text-foreground-950 font-medium text-sm leading-snug mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {formatViews(views)}
        </span>
        <span>{date}</span>
      </div>
      <div className="flex flex-wrap gap-1">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}